// @ts-nocheck
// GENERATED from PropelMapper/design@b27d324 — do not edit.
import * as React from "react";
// PMWidgetBoard.tsx — PropelMapper bento board that orchestrates PMWidget children.
//
// Owns the customizable layout: order, column span, active variant, and hidden
// state per widget — with optional localStorage persistence. In customize mode it
// renders the handle affordances (via each PMWidget) plus a "widget gallery" that
// switches a widget's A/B variant or re-adds a hidden one. Pinned widgets stay
// first and can't be hidden; admin-only widgets are filtered out for non-admins.
//
// Declarative: pass <PMWidget> children; the board reads their widgetId / span /
// variants / pinned / adminOnly props and manages everything else.
//
//   <PMWidgetBoard customizing={editing} role="admin" storageKey="pm-home">
//     <PMWidget widgetId="actions" pinned …/>
//     <PMWidget widgetId="active" span={2} …/>
//     …
//   </PMWidgetBoard>

const PMBOARD_CSS = `
.pmw-board{display:grid;grid-template-columns:1fr 1fr;gap:18px;grid-auto-flow:row dense;align-items:start}
.pmw-board.is-customizing .pmw{outline:1.5px dashed transparent}
.pmw-board.is-customizing .pmw:hover{outline-color:var(--pm-primary-light)}
.pmw-board.is-customizing .pmw > .pmw-body{pointer-events:none}
.pmw-board.is-customizing .pmw[data-keepactive] > .pmw-body{pointer-events:auto}

.pmw-galbtn{grid-column:1 / -1;display:flex;align-items:center;justify-content:center;gap:9px;border:1.6px dashed var(--pm-border-dark);border-radius:var(--pm-radius-xl,18px);padding:16px;color:var(--pm-fg-2);font:var(--pm-title-m);font-weight:600;cursor:pointer;background:none;font-family:inherit;width:100%}
.pmw-galbtn:hover{border-color:var(--pm-primary);color:var(--pm-primary)}
.pmw-galbtn .pmw-ico{width:20px;height:20px;display:inline-flex}
.pmw-galbtn .pmw-ico svg{display:block;width:100%;height:100%}

.pmw-gallery{grid-column:1 / -1;background:var(--pm-surface);border:1px solid var(--pm-border);border-radius:var(--pm-radius-xl,18px);box-shadow:var(--pm-shadow-l,0 12px 32px rgba(0,0,0,.14));padding:16px}
.pmw-gallery .pmw-gtitle{font:var(--pm-label-m);font-weight:700;text-transform:uppercase;letter-spacing:.05em;color:var(--pm-fg-3);margin:0 0 12px}
.pmw-gal-grid{display:grid;grid-template-columns:repeat(auto-fill,minmax(280px,1fr));gap:10px}
.pmw-vgroup{border:1px solid var(--pm-border);border-radius:var(--pm-radius-l,12px);padding:12px 13px;background:var(--pm-surface-secondary)}
.pmw-vgh{display:flex;align-items:center;gap:8px;font:var(--pm-title-m);font-weight:700;margin-bottom:10px}
.pmw-vgh .pmw-ico{width:18px;height:18px;color:var(--pm-primary);flex:0 0 18px}
.pmw-vgh .pmw-ico svg{display:block;width:100%;height:100%}
.pmw-vgh .hid{margin-left:auto;font:var(--pm-label-s);font-weight:700;text-transform:uppercase;letter-spacing:.04em;color:var(--pm-warning-dark);background:var(--pm-surface-warning);border-radius:var(--pm-radius-pill);padding:2px 9px}
.pmw-vopts{display:grid;grid-template-columns:1fr 1fr;gap:8px}
.pmw-vopt{display:flex;align-items:center;gap:9px;border:1.5px solid var(--pm-border);border-radius:var(--pm-radius-l,12px);padding:10px 12px;cursor:pointer;background:var(--pm-surface);text-align:left;font-family:inherit}
.pmw-vopt:hover{border-color:var(--pm-primary);background:var(--pm-primary-surface)}
.pmw-vopt .ic{width:30px;height:30px;border-radius:var(--pm-radius-m,8px);background:var(--pm-surface-variant);display:grid;place-items:center;color:var(--pm-primary);flex:0 0 30px}
.pmw-vopt .ic .pmw-ico{width:18px;height:18px}
.pmw-vopt .ic .pmw-ico svg{display:block;width:100%;height:100%}
.pmw-vopt .vl{font:var(--pm-title-m);font-weight:600;line-height:1.2}
.pmw-vopt .vl small{display:block;font:var(--pm-label-s);font-weight:600;color:var(--pm-fg-3);margin-top:2px}
.pmw-vopt .chk{display:none;margin-left:auto;color:var(--pm-primary)}
.pmw-vopt .chk .pmw-ico{width:18px;height:18px}
.pmw-vopt.is-active{opacity:.5;pointer-events:none;border-style:dashed;background:var(--pm-surface-secondary)}
.pmw-vopt.is-active .chk{display:inline-flex}
`;

function pmboardEnsureCSS() {
  if (typeof document === "undefined" || document.getElementById("pmwboard-css")) return;
  const s = document.createElement("style"); s.id = "pmwboard-css"; s.textContent = PMBOARD_CSS;
  document.head.appendChild(s);
}

function PMBIco({ name, fallback = "" }: any) {
  const I = (typeof window !== "undefined" && (window as any).PM_ICONS) || {};
  const svg = name ? (I[name] || I[name + "-outline"] || I[name + "-filled"]) : null;
  if (svg) return <span className="pmw-ico" aria-hidden="true" style={{ ["--icon-fg" as any]: "currentColor" }} dangerouslySetInnerHTML={{ __html: svg }} />;
  return <span className="pmw-ico" aria-hidden="true" style={{ fontWeight: 700, fontSize: 16, lineHeight: 1 }}>{fallback}</span>;
}

export function PMWidgetBoard({
  children,
  customizing = false,
  role = "user",
  storageKey = null,
  showGallery = true,
  onLayoutChange,
  className = "",
  style = {},
}: any) {
  pmboardEnsureCSS();
  const R = React as any;

  // Normalize children → meta array
  const items = R.useMemo(() => {
    return R.Children.toArray(children)
      .filter((c: any) => c && c.props && c.props.widgetId)
      .map((c: any) => ({
        id: c.props.widgetId,
        el: c,
        pinned: !!c.props.pinned,
        adminOnly: !!c.props.adminOnly,
        defSpan: c.props.span === 2 ? 2 : 1,
        variants: c.props.variants || null,
        defVariant: c.props.variant || (c.props.variants && c.props.variants[0] && c.props.variants[0].id) || "a",
        title: c.props.title || c.props.widgetId,
        icon: c.props.icon || "layout",
      }));
  }, [children]);

  const defaultState = () => {
    const order = items.map((i: any) => i.id);
    const span: any = {}, variant: any = {}, hidden: any = {};
    items.forEach((i: any) => { span[i.id] = i.defSpan; variant[i.id] = i.defVariant; hidden[i.id] = false; });
    return { order, span, variant, hidden };
  };

  const [state, setState] = R.useState(() => {
    if (storageKey && typeof localStorage !== "undefined") {
      try { const s = JSON.parse(localStorage.getItem(storageKey) || "null"); if (s && s.order) return s; } catch (e) {}
    }
    return defaultState();
  });

  // Reconcile when the set of widgets changes (new widget added in code, etc.)
  R.useEffect(() => {
    setState((prev: any) => {
      const next = { order: [...(prev.order || [])], span: { ...prev.span }, variant: { ...prev.variant }, hidden: { ...prev.hidden } };
      const known = new Set(next.order);
      items.forEach((i: any) => {
        if (!known.has(i.id)) next.order.push(i.id);
        if (next.span[i.id] == null) next.span[i.id] = i.defSpan;
        if (next.variant[i.id] == null) next.variant[i.id] = i.defVariant;
        if (next.hidden[i.id] == null) next.hidden[i.id] = false;
      });
      const ids = new Set(items.map((i: any) => i.id));
      next.order = next.order.filter((id: string) => ids.has(id));
      return next;
    });
  }, [items]);

  const persist = (s: any) => {
    if (storageKey && typeof localStorage !== "undefined") { try { localStorage.setItem(storageKey, JSON.stringify(s)); } catch (e) {} }
    if (onLayoutChange) onLayoutChange(s);
  };
  const update = (fn: any) => setState((prev: any) => { const s = fn(prev); persist(s); return s; });

  const metaById = (id: string) => items.find((i: any) => i.id === id);

  // Pinned first; admin filtered; hidden removed from grid
  const visibleOrder = () => {
    const pinned = items.filter((i: any) => i.pinned).map((i: any) => i.id);
    const ord = state.order.filter((id: string) => {
      const m = metaById(id); if (!m) return false;
      if (m.adminOnly && role !== "admin") return false;
      if (state.hidden[id]) return false;
      return true;
    });
    const rest = ord.filter((id: string) => pinned.indexOf(id) < 0);
    return [...pinned.filter((id: string) => ord.indexOf(id) >= 0), ...rest];
  };

  // ---- drag reorder (HTML5) ----
  const dragId = R.useRef(null);
  const onDragStart = (id: string) => (e: any) => { dragId.current = id; try { e.dataTransfer.effectAllowed = "move"; e.dataTransfer.setData("text", id); } catch (_) {} };
  const onDragOver = (overId: string) => (e: any) => {
    e.preventDefault();
    const from = dragId.current; if (!from || from === overId) return;
    const overMeta = metaById(overId); if (overMeta && overMeta.pinned) return; // never displace pinned slot
    update((prev: any) => {
      const order = [...prev.order];
      const fi = order.indexOf(from), oi = order.indexOf(overId);
      if (fi < 0 || oi < 0) return prev;
      order.splice(fi, 1); order.splice(order.indexOf(overId) + (fi < oi ? 1 : 0), 0, from);
      return { ...prev, order };
    });
  };
  const onDragEnd = () => { dragId.current = null; };

  const setVariant = (id: string, v: string) => update((p: any) => ({ ...p, variant: { ...p.variant, [id]: v }, hidden: { ...p.hidden, [id]: false } }));
  const setSpan = (id: string, sp: number) => update((p: any) => ({ ...p, span: { ...p.span, [id]: sp } }));
  const setHidden = (id: string, h: boolean) => update((p: any) => ({ ...p, hidden: { ...p.hidden, [id]: h } }));

  const [galOpen, setGalOpen] = R.useState(false);

  const renderWidget = (id: string) => {
    const m = metaById(id); if (!m) return null;
    const draggable = customizing && !m.pinned;
    const extra: any = {
      key: id,
      span: state.span[id],
      variant: state.variant[id],
      customizing,
      onResize: m.pinned ? undefined : (sp: number) => setSpan(id, sp),
      onHide: m.pinned ? undefined : () => setHidden(id, true),
      // The whole card is the drag target in customize mode (the handle is the
      // visual grab cue); display:contents wrappers can't receive drag events.
      draggable,
      onDragStart: draggable ? onDragStart(id) : undefined,
      onDragOver: customizing ? onDragOver(id) : undefined,
      onDragEnd: draggable ? onDragEnd : undefined,
      "data-keepactive": m.pinned ? "" : undefined,
    };
    return R.cloneElement(m.el, extra);
  };

  // ---- gallery ----
  const galleryWidgets = items.filter((i: any) => !(i.adminOnly && role !== "admin"));
  const renderGallery = () => (
    <div className="pmw-gallery">
      <p className="pmw-gtitle">Pick a layout for each widget</p>
      <div className="pmw-gal-grid">
        {galleryWidgets.map((m: any) => {
          const hidden = !!state.hidden[m.id];
          const cur = state.variant[m.id];
          const vs = m.variants && m.variants.length ? m.variants : [{ id: m.defVariant, label: "Default", icon: m.icon }];
          return (
            <div className="pmw-vgroup" key={m.id}>
              <div className="pmw-vgh"><PMBIco name={m.icon} fallback="▦" />{m.title}{hidden ? <span className="hid">Hidden</span> : null}</div>
              <div className="pmw-vopts" style={vs.length === 1 ? { gridTemplateColumns: "1fr" } : undefined}>
                {vs.map((v: any) => {
                  const active = !hidden && cur === v.id;
                  return (
                    <button type="button" key={v.id} className={"pmw-vopt" + (active ? " is-active" : "")} onClick={() => setVariant(m.id, v.id)}>
                      <span className="ic"><PMBIco name={v.icon || m.icon} fallback="▦" /></span>
                      <span className="vl">{v.label}<small>{active ? "Active" : (hidden ? "Show this" : "Switch")}</small></span>
                      <span className="chk"><PMBIco name="check-circle" fallback="✓" /></span>
                    </button>
                  );
                })}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );

  return (
    <div className={"pmw-board" + (customizing ? " is-customizing" : "") + (className ? " " + className : "")} style={style}>
      {customizing && showGallery ? (
        <React.Fragment>
          <button type="button" className="pmw-galbtn" onClick={() => setGalOpen((o: boolean) => !o)}>
            <PMBIco name="layout" fallback="▦" />Widget gallery
          </button>
          {galOpen ? renderGallery() : null}
        </React.Fragment>
      ) : null}
      {visibleOrder().map((id: string) => renderWidget(id))}
    </div>
  );
}
